import {
  Page,
  Document,
  Text,
  Font,
  PDFViewer,
  View,
  Image
} from '@react-pdf/renderer'
//@ts-ignore
import font from '../../../assets/fonts/OpenSauceSans-Bold.ttf'
//@ts-ignore
import fontRegular from '../../../assets/fonts/OpenSauceSans-Regular.ttf'
import { formatPipe } from '../../../utils/utils'

const CashPdf: React.FC<any> = ({
  bodyValues = {},
  type = 'bsDirectCashFlowStatement',
  period = "",
  infoAccount = {}
}) => {
  Font.register({
    family: 'Open Sans',
    fonts: [{ src: font }],
  })

  Font.register({
    family: 'Open Sans-normal',
    fonts: [{ src: fontRegular }],
  })

  const getDate = (date: string) => {
      if (date) {
        const [year, month, day] = date?.split("-")
        return `${month}/${day}/${year}`
      }
      return ""
  }

  return (
      <Document title={`mayor-analitico`}>
        <Page size="LETTER" style={{ padding: 30 }}>
          <View
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >

            { infoAccount?.image ? (  // Add null check
              <Image 
                  src={infoAccount.image}       
                  style={{ 
                      objectFit: 'contain', 
                      width: 80, 
                      height: 80 
                  }}
              />
            ) : null }


            <Text
              style={{
                marginBottom: 10,
                fontFamily: 'Open Sans',
                fontSize: 15,
              }}
            >
              
            </Text>

            <Text
              style={{
                marginBottom: 10,
                fontFamily: 'Open Sans',
                fontSize: 15,
              }}
            >
              {bodyValues?.tenant?.business_name}
            </Text>

            <Text
              style={{
                marginBottom: 10,
                fontFamily: 'Open Sans-normal',
                fontSize: 10,
              }}
            >
              Estado de Flujo de Efectivo
            </Text>

            <Text
              style={{
                marginBottom: 10,
                fontFamily: 'Open Sans-normal',
                fontSize: 10,
              }}
            >
              Periodo: {period}
            </Text>
          </View>

          <View style={{ marginTop: 20 }}>
            <Text
              style={{
                marginBottom: 10,
                fontFamily: 'Open Sans',
                fontSize: 10,
              }}
            >
              Flujo del efectivo de actividades de operación
            </Text>

            {/**Tabla horizontal en flujo de efectivo */}
            <View>
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: 10,
                  backgroundColor: '#F9F9F9',
                  borderRadius: 5,
                }}
              >
                <View style={{ width: '70%' }}>
                  <Text
                    style={{
                      fontFamily: 'Open Sans-normal',
                      fontSize: 10,
                    }}
                  >
                    Cobros recibidos a los clientes
                  </Text>
                </View>

                <View style={{ width: '25%', textAlign: 'right' }}>
                  <Text
                    style={{
                      fontFamily: 'Open Sans-normal',
                      fontSize: 10,
                      color: bodyValues[type]?.cobroClientes < 0 ? 'red': ''
                    }}
                  >
                    {bodyValues[type]?.cobroClientes < 0 ? `(${formatPipe((bodyValues[type]?.cobroClientes *-1) +"", false, 2, -999999999999)})` : formatPipe(bodyValues[type]?.cobroClientes, false, 2, -999999999999)}
                  </Text>
                </View>
              </View>

              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: 10,
                  borderRadius: 5,
                }}
              >
                <View style={{ width: '70%' }}>
                  <Text
                    style={{
                      fontFamily: 'Open Sans-normal',
                      fontSize: 10,
                    }}
                  >
                    Otros ingresos
                  </Text>
                </View>

                <View style={{ width: '25%', textAlign: 'right' }}>
                  <Text
                    style={{
                      fontFamily: 'Open Sans-normal',
                      fontSize: 10,
                      color: bodyValues[type]?.otrosIngresos < 0 ? 'red': ''
                    }}
                  >
                    {bodyValues[type]?.otrosIngresos < 0 ? `(${formatPipe((bodyValues[type]?.otrosIngresos *-1) +"", false, 2, -999999999999)})` : formatPipe(bodyValues[type]?.otrosIngresos, false, 2, -999999999999)}
                  </Text>
                </View>
              </View>

              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: 10,
                  borderRadius: 5,
                  backgroundColor: '#F9F9F9',
                }}
              >
                <View style={{ width: '70%' }}>
                  <Text
                    style={{
                      fontFamily: 'Open Sans-normal',
                      fontSize: 10,
                    }}
                  >
                    Pago de proveedores
                  </Text>
                </View>

                <View style={{ width: '25%', textAlign: 'right' }}>
                  <Text
                    style={{
                      fontFamily: 'Open Sans-normal',
                      fontSize: 10,
                      color: bodyValues[type]?.pagoProveedores < 0 ? 'red': ''
                    }}
                  >
                    {bodyValues[type]?.pagoProveedores < 0 ? `(${formatPipe((bodyValues[type]?.pagoProveedores *-1) +"", false, 2, -999999999999)})` : formatPipe(bodyValues[type]?.pagoProveedores, false, 2, -999999999999)}
                  </Text>
                </View>
              </View>

              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: 10,
                  borderRadius: 5,
                }}
              >
                <View style={{ width: '70%' }}>
                  <Text
                    style={{
                      fontFamily: 'Open Sans-normal',
                      fontSize: 10,
                    }}
                  >
                    Pago de empleados
                  </Text>
                </View>

                <View style={{ width: '25%', textAlign: 'right' }}>
                  <Text
                    style={{
                      fontFamily: 'Open Sans-normal',
                      fontSize: 10,
                      color: bodyValues[type]?.pagoEmpleados < 0 ? 'red': ''
                    }}
                  >
                    {bodyValues[type]?.pagoEmpleados < 0 ? `(${formatPipe((bodyValues[type]?.pagoEmpleados *-1) +"", false, 2, -999999999999)})` : formatPipe(bodyValues[type]?.pagoEmpleados, false, 2, -999999999999)}
                  </Text>
                </View>
              </View>

              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: 10,
                  borderRadius: 5,
                  backgroundColor: '#F9F9F9',
                }}
              >
                <View style={{ width: '70%' }}>
                  <Text
                    style={{
                      fontFamily: 'Open Sans-normal',
                      fontSize: 10,
                    }}
                  >
                    Pago de impuestos
                  </Text>
                </View>

                <View style={{ width: '25%', textAlign: 'right' }}>
                  <Text
                    style={{
                      fontFamily: 'Open Sans-normal',
                      fontSize: 10,
                      color: bodyValues[type]?.pagoImpuestos < 0 ? 'red': ''
                    }}
                  >
                    {bodyValues[type]?.pagoImpuestos < 0 ? `(${formatPipe((bodyValues[type]?.pagoImpuestos *-1) +"", false, 2, -999999999999)})` : formatPipe(bodyValues[type]?.pagoImpuestos, false, 2, -999999999999)}
                  </Text>
                </View>
              </View>

              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: 10,
                  borderRadius: 5,
                }}
              >
                <View style={{ width: '70%' }}>
                  <Text
                    style={{
                      fontFamily: 'Open Sans-normal',
                      fontSize: 10,
                    }}
                  >
                    Pago de gastos operativos
                  </Text>
                </View>

                <View style={{ width: '25%', textAlign: 'right' }}>
                  <Text
                    style={{
                      fontFamily: 'Open Sans-normal',
                      fontSize: 10,
                      color: bodyValues[type]?.pagoGastosOperativos < 0 ? 'red': ''
                    }}
                  >
                    {bodyValues[type]?.pagoGastosOperativos < 0 ? `(${formatPipe((bodyValues[type]?.pagoGastosOperativos *-1) +"", false, 2, -999999999999)})` : formatPipe(bodyValues[type]?.pagoGastosOperativos, false, 2, -999999999999)}
                  </Text>
                </View>
              </View>

              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: 10,
                  borderRadius: 5,
                  backgroundColor: '#F9F9F9',
                }}
              >
                <View style={{ width: '70%' }}>
                  <Text
                    style={{
                      fontFamily: 'Open Sans-normal',
                      fontSize: 10,
                    }}
                  >
                    Pago de intereses
                  </Text>
                </View>

                <View style={{ width: '25%', textAlign: 'right' }}>
                  <Text
                    style={{
                      fontFamily: 'Open Sans-normal',
                      fontSize: 10,
                      color: bodyValues[type]?.pagoIntereses < 0 ? 'red': ''
                    }}
                  >
                    {bodyValues[type]?.pagoIntereses < 0 ? `(${formatPipe((bodyValues[type]?.pagoIntereses *-1) +"", false, 2, -999999999999)})` : formatPipe(bodyValues[type]?.pagoIntereses, false, 2, -999999999999)}
                  </Text>
                </View>
              </View>

              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: 10,
                  borderRadius: 5,
                }}
              >
                <View style={{ width: '70%' }}>
                  <Text
                    style={{
                      fontFamily: 'Open Sans-normal',
                      fontSize: 10,
                    }}
                  >
                    Otros Egresos
                  </Text>
                </View>

                <View style={{ width: '25%', textAlign: 'right' }}>
                  <Text
                    style={{
                      fontFamily: 'Open Sans-normal',
                      fontSize: 10,
                      color: bodyValues[type]?.otrosEgresos < 0 ? 'red': ''
                    }}
                  >
                    {bodyValues[type]?.otrosEgresos < 0 ? `(${formatPipe((bodyValues[type]?.otrosEgresos *-1) +"", false, 2, -999999999999)})` : formatPipe(bodyValues[type]?.otrosEgresos, false, 2, -999999999999)}
                  </Text>
                </View>
              </View>

              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: 10,
                  borderRadius: 5,
                  marginTop: 20
                }}
              >
                <View style={{ width: '70%' }}>
                  <Text
                    style={{
                      fontFamily: 'Open Sans',
                      fontSize: 10,
                      color: '#04489A'
                    }}
                  >
                    Efectivo neto provisto por las act. operación
                  </Text>
                </View>

                <View style={{ width: '25%', textAlign: 'right' }}>
                  <Text
                    style={{
                      fontFamily: 'Open Sans',
                      fontSize: 10,
                      color: '#04489A',
                    }}
                  >
                    {formatPipe(bodyValues[type]?.netCashOperacion, false, 2, -999999999999)}
                  </Text>
                </View>
              </View>

            </View>
          </View>

          <View break={true}>
            <View>
              {bodyValues[type]?.appendix?.cobroClientesFlows?.length > 0 && (
                <>
                  <View style={{ marginBottom: 20 }}>
                    <Text
                      style={{
                        fontFamily: 'Open Sans',
                        fontSize: 10,
                      }}
                    >
                      Flujo de cobro de clientes
                    </Text>
                  </View>

                  <View
                    style={{
                      width: '100%',
                      padding: 10,
                      backgroundColor: '#F9F9F9',
                      borderRadius: 5,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    {/** Fecha / tipo / monto / descripcion */}
                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Fecha
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Tipo
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Monto
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Descripción
                      </Text>
                    </View>
                  </View>

                  {bodyValues[type]?.appendix?.cobroClientesFlows.map((v, i) => (
                    <View
                      style={{
                        width: '100%',
                        padding: 10,
                        borderRadius: 5,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        backgroundColor: i % 2 === 0 ? '' : '#E6EBF6',
                      }}
                    >
                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {getDate(v?.date)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.type}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {formatPipe(v?.bsAmount ? v?.bsAmount : v?.usdAmount, false, 2, -999999999999)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.description}
                        </Text>
                      </View>
                    </View>
                  ))}
                </>
              )}
            </View>

            <View>
              {bodyValues[type]?.appendix?.otrosIngresosFlows?.length > 0 && (
                <>
                  <View style={{ marginBottom: 20, marginTop: 30 }}>
                    <Text
                      style={{
                        fontFamily: 'Open Sans',
                        fontSize: 10,
                      }}
                    >
                      Flujo de otros ingresos
                    </Text>
                  </View>

                  <View
                    style={{
                      width: '100%',
                      padding: 10,
                      backgroundColor: '#F9F9F9',
                      borderRadius: 5,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    {/** Fecha / tipo / monto / descripcion */}
                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Fecha
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Tipo
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Monto
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Descripción
                      </Text>
                    </View>
                  </View>

                  {bodyValues[type]?.appendix?.otrosIngresosFlows.map((v, i) => (
                    <View
                      style={{
                        width: '100%',
                        padding: 10,
                        borderRadius: 5,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        backgroundColor: i % 2 === 0 ? '' : '#E6EBF6',
                      }}
                    >
                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {getDate(v?.date)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.type}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {formatPipe(v?.bsAmount ? v?.bsAmount : v?.usdAmount, false, 2, -999999999999)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.description}
                        </Text>
                      </View>
                    </View>
                  ))}
                </>
              )}
            </View>

            <View>
              {bodyValues[type]?.appendix?.pagoProveedoresFlows?.length > 0 && (
                <>
                  <View style={{ marginBottom: 20, marginTop: 30}}>
                    <Text
                      style={{
                        fontFamily: 'Open Sans',
                        fontSize: 10,
                      }}
                    >
                      Flujo de pago de proveedores
                    </Text>
                  </View>

                  <View
                    style={{
                      width: '100%',
                      padding: 10,
                      backgroundColor: '#F9F9F9',
                      borderRadius: 5,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    {/** Fecha / tipo / monto / descripcion */}
                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Fecha
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Tipo
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Monto
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Descripción
                      </Text>
                    </View>
                  </View>

                  {bodyValues[type]?.appendix?.pagoProveedoresFlows.map((v, i) => (
                    <View
                      style={{
                        width: '100%',
                        padding: 10,
                        borderRadius: 5,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        backgroundColor: i % 2 === 0 ? '' : '#E6EBF6',
                      }}
                    >
                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {getDate(v?.date)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.type}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                        {formatPipe(v?.bsAmount ? v?.bsAmount : v?.usdAmount, false, 2, -999999999999)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.description}
                        </Text>
                      </View>
                    </View>
                  ))}
                </>
              )}
            </View>

            <View>
              {bodyValues[type]?.appendix?.pagoEmpleadosFlows?.length > 0 && (
                <>
                  <View style={{ marginBottom: 20, marginTop: 30}}>
                    <Text
                      style={{
                        fontFamily: 'Open Sans',
                        fontSize: 10,
                      }}
                    >
                      Flujo de pago de empleados
                    </Text>
                  </View>

                  <View
                    style={{
                      width: '100%',
                      padding: 10,
                      backgroundColor: '#F9F9F9',
                      borderRadius: 5,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    {/** Fecha / tipo / monto / descripcion */}
                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Fecha
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Tipo
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Monto
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Descripción
                      </Text>
                    </View>
                  </View>

                  {bodyValues[type]?.appendix?.pagoEmpleadosFlows.map((v, i) => (
                    <View
                      style={{
                        width: '100%',
                        padding: 10,
                        borderRadius: 5,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        backgroundColor: i % 2 === 0 ? '' : '#E6EBF6',
                      }}
                    >
                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {getDate(v?.date)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.type}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {formatPipe(v?.bsAmount ? v?.bsAmount : v?.usdAmount, false, 2, -999999999999)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.description}
                        </Text>
                      </View>
                    </View>
                  ))}
                </>
              )}
            </View>

            <View>
              {bodyValues[type]?.appendix?.pagoImpuestosFlows?.length > 0 && (
                <>
                  <View style={{ marginBottom: 20, marginTop: 30}}>
                    <Text
                      style={{
                        fontFamily: 'Open Sans',
                        fontSize: 10,
                      }}
                    >
                      Flujo de pago de impuestos
                    </Text>
                  </View>

                  <View
                    style={{
                      width: '100%',
                      padding: 10,
                      backgroundColor: '#F9F9F9',
                      borderRadius: 5,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    {/** Fecha / tipo / monto / descripcion */}
                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Fecha
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Tipo
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Monto
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Descripción
                      </Text>
                    </View>
                  </View>

                  {bodyValues[type]?.appendix?.pagoImpuestosFlows.map((v, i) => (
                    <View
                      style={{
                        width: '100%',
                        padding: 10,
                        borderRadius: 5,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        backgroundColor: i % 2 === 0 ? '' : '#E6EBF6',
                      }}
                    >
                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {getDate(v?.date)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.type}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {formatPipe(v?.bsAmount ? v?.bsAmount : v?.usdAmount, false, 2, -999999999999)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.description}
                        </Text>
                      </View>
                    </View>
                  ))}
                </>
              )}
            </View>

            <View>
              {bodyValues[type]?.appendix?.pagoGastosOperativosFlows?.length > 0 && (
                <>
                  <View style={{ marginBottom: 20, marginTop: 30}}>
                    <Text
                      style={{
                        fontFamily: 'Open Sans',
                        fontSize: 10,
                      }}
                    >
                      Flujo de gastos operativos
                    </Text>
                  </View>

                  <View
                    style={{
                      width: '100%',
                      padding: 10,
                      backgroundColor: '#F9F9F9',
                      borderRadius: 5,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    {/** Fecha / tipo / monto / descripcion */}
                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Fecha
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Tipo
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Monto
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Descripción
                      </Text>
                    </View>
                  </View>

                  {bodyValues[type]?.appendix?.pagoGastosOperativosFlows.map((v, i) => (
                    <View
                      style={{
                        width: '100%',
                        padding: 10,
                        borderRadius: 5,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        backgroundColor: i % 2 === 0 ? '' : '#E6EBF6',
                      }}
                    >
                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {getDate(v?.date)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.type}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {formatPipe(v?.bsAmount ? v?.bsAmount : v?.usdAmount, false, 2, -999999999999)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.description}
                        </Text>
                      </View>
                    </View>
                  ))}
                </>
              )}
            </View>

            <View>
              {bodyValues[type]?.appendix?.pagoInteresesFlows?.length > 0 && (
                <>
                  <View style={{ marginBottom: 20, marginTop: 30}}>
                    <Text
                      style={{
                        fontFamily: 'Open Sans',
                        fontSize: 10,
                      }}
                    >
                      Flujo de pago de intereses
                    </Text>
                  </View>

                  <View
                    style={{
                      width: '100%',
                      padding: 10,
                      backgroundColor: '#F9F9F9',
                      borderRadius: 5,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    {/** Fecha / tipo / monto / descripcion */}
                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Fecha
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Tipo
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Monto
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Descripción
                      </Text>
                    </View>
                  </View>

                  {bodyValues[type]?.appendix?.pagoInteresesFlows.map((v, i) => (
                    <View
                      style={{
                        width: '100%',
                        padding: 10,
                        borderRadius: 5,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        backgroundColor: i % 2 === 0 ? '' : '#E6EBF6',
                      }}
                    >
                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {getDate(v?.date)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.type}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {formatPipe(v?.bsAmount ? v?.bsAmount : v?.usdAmount, false, 2, -999999999999)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.description}
                        </Text>
                      </View>
                    </View>
                  ))}
                </>
              )}
            </View>

            <View>
              {bodyValues[type]?.appendix?.compraEquiposFlows?.length > 0 && (
                <>
                  <View style={{ marginBottom: 20, marginTop: 30}}>
                    <Text
                      style={{
                        fontFamily: 'Open Sans',
                        fontSize: 10,
                      }}
                    >
                      Flujo de compra de equipos
                    </Text>
                  </View>

                  <View
                    style={{
                      width: '100%',
                      padding: 10,
                      backgroundColor: '#F9F9F9',
                      borderRadius: 5,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    {/** Fecha / tipo / monto / descripcion */}
                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Fecha
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Tipo
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Monto
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Descripción
                      </Text>
                    </View>
                  </View>

                  {bodyValues[type]?.appendix?.compraEquiposFlows.map((v, i) => (
                    <View
                      style={{
                        width: '100%',
                        padding: 10,
                        borderRadius: 5,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        backgroundColor: i % 2 === 0 ? '' : '#E6EBF6',
                      }}
                    >
                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {getDate(v?.date)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.type}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {formatPipe(v?.bsAmount ? v?.bsAmount : v?.usdAmount, false, 2, -999999999999)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.description}
                        </Text>
                      </View>
                    </View>
                  ))}
                </>
              )}
            </View>

            <View>
              {bodyValues[type]?.appendix?.ventaEquiposFlows?.length > 0 && (
                <>
                  <View style={{ marginBottom: 20, marginTop: 30}}>
                    <Text
                      style={{
                        fontFamily: 'Open Sans',
                        fontSize: 10,
                      }}
                    >
                      Flujo de venta de equipos
                    </Text>
                  </View>

                  <View
                    style={{
                      width: '100%',
                      padding: 10,
                      backgroundColor: '#F9F9F9',
                      borderRadius: 5,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    {/** Fecha / tipo / monto / descripcion */}
                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Fecha
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Tipo
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Monto
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Descripción
                      </Text>
                    </View>
                  </View>

                  {bodyValues[type]?.appendix?.ventaEquiposFlows.map((v, i) => (
                    <View
                      style={{
                        width: '100%',
                        padding: 10,
                        borderRadius: 5,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        backgroundColor: i % 2 === 0 ? '' : '#E6EBF6',
                      }}
                    >
                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {getDate(v?.date)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.type}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {formatPipe(v?.bsAmount ? v?.bsAmount : v?.usdAmount, false, 2, -999999999999)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.description}
                        </Text>
                      </View>
                    </View>
                  ))}
                </>
              )}
            </View>

            <View>
              {bodyValues[type]?.appendix?.compraInmueblesFlows?.length > 0 && (
                <>
                  <View style={{ marginBottom: 20, marginTop: 30}}>
                    <Text
                      style={{
                        fontFamily: 'Open Sans',
                        fontSize: 10,
                      }}
                    >
                      Flujo de compra de inmuebles
                    </Text>
                  </View>

                  <View
                    style={{
                      width: '100%',
                      padding: 10,
                      backgroundColor: '#F9F9F9',
                      borderRadius: 5,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    {/** Fecha / tipo / monto / descripcion */}
                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Fecha
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Tipo
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Monto
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Descripción
                      </Text>
                    </View>
                  </View>

                  {bodyValues[type]?.appendix?.compraInmueblesFlows.map((v, i) => (
                    <View
                      style={{
                        width: '100%',
                        padding: 10,
                        borderRadius: 5,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        backgroundColor: i % 2 === 0 ? '' : '#E6EBF6',
                      }}
                    >
                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {getDate(v?.date)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.type}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {formatPipe(v?.bsAmount ? v?.bsAmount : v?.usdAmount, false, 2, -999999999999)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.description}
                        </Text>
                      </View>
                    </View>
                  ))}
                </>
              )}
            </View>

            <View>
              {bodyValues[type]?.appendix?.ventaInmueblesFlows?.length > 0 && (
                <>
                  <View style={{ marginBottom: 20, marginTop: 30}}>
                    <Text
                      style={{
                        fontFamily: 'Open Sans',
                        fontSize: 10,
                      }}
                    >
                      Flujo de venta de inmueble
                    </Text>
                  </View>

                  <View
                    style={{
                      width: '100%',
                      padding: 10,
                      backgroundColor: '#F9F9F9',
                      borderRadius: 5,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    {/** Fecha / tipo / monto / descripcion */}
                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Fecha
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Tipo
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Monto
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Descripción
                      </Text>
                    </View>
                  </View>

                  {bodyValues[type]?.appendix?.ventaInmueblesFlows.map((v, i) => (
                    <View
                      style={{
                        width: '100%',
                        padding: 10,
                        borderRadius: 5,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        backgroundColor: i % 2 === 0 ? '' : '#E6EBF6',
                      }}
                    >
                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {getDate(v?.date)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.type}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {formatPipe(v?.bsAmount ? v?.bsAmount : v?.usdAmount, false, 2, -999999999999)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.description}
                        </Text>
                      </View>
                    </View>
                  ))}
                </>
              )}
            </View>

            <View>
              {bodyValues[type]?.appendix?.ingresosCreditosFlows?.length > 0 && (
                <>
                  <View style={{ marginBottom: 20, marginTop: 30}}>
                    <Text
                      style={{
                        fontFamily: 'Open Sans',
                        fontSize: 10,
                      }}
                    >
                      Flujo de crédito de ingresos
                    </Text>
                  </View>

                  <View
                    style={{
                      width: '100%',
                      padding: 10,
                      backgroundColor: '#F9F9F9',
                      borderRadius: 5,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    {/** Fecha / tipo / monto / descripcion */}
                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Fecha
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Tipo
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Monto
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Descripción
                      </Text>
                    </View>
                  </View>

                  {bodyValues[type]?.appendix?.ingresosCreditosFlows.map((v, i) => (
                    <View
                      style={{
                        width: '100%',
                        padding: 10,
                        borderRadius: 5,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        backgroundColor: i % 2 === 0 ? '' : '#E6EBF6',
                      }}
                    >
                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {getDate(v?.date)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.type}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {formatPipe(v?.bsAmount ? v?.bsAmount : v?.usdAmount, false, 2, -999999999999)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.description}
                        </Text>
                      </View>
                    </View>
                  ))}
                </>
              )}
            </View>

            <View>
              {bodyValues[type]?.appendix?.pagoCreditosFlows?.length > 0 && (
                <>
                  <View style={{ marginBottom: 20, marginTop: 30}}>
                    <Text
                      style={{
                        fontFamily: 'Open Sans',
                        fontSize: 10,
                      }}
                    >
                      Flujo de pago de créditos
                    </Text>
                  </View>

                  <View
                    style={{
                      width: '100%',
                      padding: 10,
                      backgroundColor: '#F9F9F9',
                      borderRadius: 5,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    {/** Fecha / tipo / monto / descripcion */}
                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Fecha
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Tipo
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Monto
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Descripción
                      </Text>
                    </View>
                  </View>

                  {bodyValues[type]?.appendix?.pagoCreditosFlows.map((v, i) => (
                    <View
                      style={{
                        width: '100%',
                        padding: 10,
                        borderRadius: 5,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        backgroundColor: i % 2 === 0 ? '' : '#E6EBF6',
                      }}
                    >
                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {getDate(v?.date)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.type}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {formatPipe(v?.bsAmount ? v?.bsAmount : v?.usdAmount, false, 2, -999999999999)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.description}
                        </Text>
                      </View>
                    </View>
                  ))}
                </>
              )}
            </View>

            <View>
              {bodyValues[type]?.appendix?.ingresosCapitalFlows?.length > 0 && (
                <>
                  <View style={{ marginBottom: 20, marginTop: 30}}>
                    <Text
                      style={{
                        fontFamily: 'Open Sans',
                        fontSize: 10,
                      }}
                    >
                      Flujo de ingresos de capital
                    </Text>
                  </View>

                  <View
                    style={{
                      width: '100%',
                      padding: 10,
                      backgroundColor: '#F9F9F9',
                      borderRadius: 5,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    {/** Fecha / tipo / monto / descripcion */}
                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Fecha
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Tipo
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Monto
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Descripción
                      </Text>
                    </View>
                  </View>

                  {bodyValues[type]?.appendix?.ingresosCapitalFlows.map((v, i) => (
                    <View
                      style={{
                        width: '100%',
                        padding: 10,
                        borderRadius: 5,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        backgroundColor: i % 2 === 0 ? '' : '#E6EBF6',
                      }}
                    >
                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {getDate(v?.date)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.type}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {formatPipe(v?.bsAmount ? v?.bsAmount : v?.usdAmount, false, 2, -999999999999)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.description}
                        </Text>
                      </View>
                    </View>
                  ))}
                </>
              )}
            </View>

            <View>
              {bodyValues[type]?.appendix?.pagoDividendosFlows?.length > 0 && (
                <>
                  <View style={{ marginBottom: 20, marginTop: 30}}>
                    <Text
                      style={{
                        fontFamily: 'Open Sans',
                        fontSize: 10,
                      }}
                    >
                      Flujo de pago de dividendos
                    </Text>
                  </View>

                  <View
                    style={{
                      width: '100%',
                      padding: 10,
                      backgroundColor: '#F9F9F9',
                      borderRadius: 5,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    {/** Fecha / tipo / monto / descripcion */}
                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Fecha
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Tipo
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Monto
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Descripción
                      </Text>
                    </View>
                  </View>

                  {bodyValues[type]?.appendix?.pagoDividendosFlows.map((v, i) => (
                    <View
                      style={{
                        width: '100%',
                        padding: 10,
                        borderRadius: 5,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        backgroundColor: i % 2 === 0 ? '' : '#E6EBF6',
                      }}
                    >
                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {getDate(v?.date)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.type}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {formatPipe(v?.bsAmount ? v?.bsAmount : v?.usdAmount, false, 2, -999999999999)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.description}
                        </Text>
                      </View>
                    </View>
                  ))}
                </>
              )}
            </View>

            <View>
              {bodyValues[type]?.appendix?.otrosEgresosFlows?.length > 0 && (
                <>
                  <View style={{ marginBottom: 20, marginTop: 30}}>
                    <Text
                      style={{
                        fontFamily: 'Open Sans',
                        fontSize: 10,
                      }}
                    >
                      Flujo de otros egresos
                    </Text>
                  </View>

                  <View
                    style={{
                      width: '100%',
                      padding: 10,
                      backgroundColor: '#F9F9F9',
                      borderRadius: 5,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    {/** Fecha / tipo / monto / descripcion */}
                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Fecha
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Tipo
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Monto
                      </Text>
                    </View>

                    <View style={{ width: '20%' }}>
                      <Text
                        style={{
                          fontFamily: 'Open Sans-normal',
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                      >
                        Descripción
                      </Text>
                    </View>
                  </View>

                  {bodyValues[type]?.appendix?.otrosEgresosFlows.map((v, i) => (
                    <View
                      style={{
                        width: '100%',
                        padding: 10,
                        borderRadius: 5,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        backgroundColor: i % 2 === 0 ? '' : '#E6EBF6',
                      }}
                    >
                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {getDate(v?.date)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.type}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {formatPipe(v?.bsAmount ? v?.bsAmount : v?.usdAmount, false, 2, -999999999999)}
                        </Text>
                      </View>

                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: 'Open Sans-normal',
                            fontSize: 10,
                            textAlign: 'center',
                          }}
                        >
                          {v?.description}
                        </Text>
                      </View>
                    </View>
                  ))}
                </>
              )}
            </View>

          </View>
        </Page>
      </Document>
  )
}

export default CashPdf
